import * as React from 'react'

function SvgAirconIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x={1.428}
        y={2.571}
        width={25.143}
        height={16}
        rx={2}
        stroke="currentColor"
      />
      <path
        d="M6 18.571l.687-2.06a2 2 0 011.897-1.368h10.832a2 2 0 011.897 1.367L22 18.571"
        stroke="currentColor"
      />
      <circle cx={21.428} cy={7.714} stroke="currentColor" r={1.714} />
      <path
        d="M8.286 23.143l2.285 2.285M12.857 23.143l2.286 2.285M17.428 23.143l2.286 2.285"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default SvgAirconIcon
